import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LOCATIONS, OPENING_HOURS, PHONE } from '../data/locations';
export function Footer() {
  return <footer className="w-full border-t border-lotus-500/20 bg-ink-900" data-id="element-21" data-mp="32pp6e2e63v5g">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-16 sm:px-8 md:grid-cols-3" data-id="element-22" data-mp="36qheutf7tw0o">
        <div data-id="element-23" data-mp="3ug3e1gvl8b8o">
          <Logo showTagline data-id="element-24" data-mp="3ugbpd4c2b8hr" />
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-neutral-400" data-id="element-25" data-mp="3ucxsgbm63rhp">
            Professional massage &amp; relaxation services across Queensland. Services for men
            only, ages 18+.
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-neutral-300" data-id="element-26" data-mp="3qd6u9muba935">
            <PhoneIcon className="h-4 w-4 text-lotus-500" aria-hidden="true" data-id="element-27" data-mp="29z6tyark0hfd" />
            <a href={`tel:${PHONE.replace(/\s/g, '')}`} className="hover:text-lotus-500" data-id="element-28" data-mp="2a19u3nmf7qxt">
              {PHONE}
            </a>
          </p>
          <p className="mt-2 flex items-center gap-2 text-sm text-neutral-300" data-id="element-29" data-mp="3l90l3octskvk">
            <ClockIcon className="h-4 w-4 text-lotus-500" aria-hidden="true" data-id="element-30" data-mp="3gah0psdvrh5b" />
            {OPENING_HOURS}
          </p>
        </div>

        <div data-id="element-31" data-mp="3v8rhxwouzbyt">
          <h2 className="text-[11px] font-medium uppercase tracking-[0.3em] text-lotus-500" data-id="element-32" data-mp="3v8hpm2gccspy">
            Quick links
          </h2>
          <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400" data-id="element-33" data-mp="3qapwx67vh2kp">
            <li data-id="element-34" data-mp="81flfk1o45ye">
              <Link to="/" className="hover:text-lotus-500" data-id="element-35" data-mp="80xmugrj9fnb">
                Home
              </Link>
            </li>
            <li data-id="element-36" data-mp="hstrybs1e611">
              <Link to="/locations" className="hover:text-lotus-500" data-id="element-37" data-mp="htd0j1vsri2e">
                Locations
              </Link>
            </li>
            <li data-id="element-38" data-mp="cu8u2j09byfr">
              <Link to="/services" className="hover:text-lotus-500" data-id="element-39" data-mp="cvtom8mknhdm">
                Services &amp; Pricing
              </Link>
            </li>
            <li data-id="element-40" data-mp="msg5ynfovqaw">
              <Link to="/book" className="hover:text-lotus-500" data-id="element-41" data-mp="msxzvdevpsfn">
                Book a session
              </Link>
            </li>
            <li data-id="element-42" data-mp="twxqz8ok588s">
              <Link to="/contact" className="hover:text-lotus-500" data-id="element-43" data-mp="tta2inxyzc0x">
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div data-id="element-44" data-mp="13sis74lsy4hh">
          <h2 className="text-[11px] font-medium uppercase tracking-[0.3em] text-lotus-500" data-id="element-45" data-mp="13rzigb6b2mej">
            Our studios
          </h2>
          <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400" data-id="element-46" data-mp="1clmaprbb17iz">
            {LOCATIONS.map(loc => <li key={loc.slug} className="flex gap-2" data-id="element-47" data-mp="1hk5xftxq2nce">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-500" aria-hidden="true" data-id="element-48" data-mp="1hms4lsgpb0u3" />
                <Link to={`/locations/${loc.slug}`} className="hover:text-lotus-500" data-id="element-49" data-mp="1rj4zgtnzfkqf">
                  <span className="text-neutral-200" data-id="element-50" data-mp="3obolfarw99ex">{loc.suburb}</span> — {loc.name}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5" data-id="element-51" data-mp="2af3t5raxr5k5">
        <p className="mx-auto w-full max-w-7xl px-5 py-6 text-xs text-neutral-500 sm:px-8" data-id="element-52" data-mp="2afx0ouhpxz3c">
          © {new Date().getFullYear()} ME time. All rights reserved.
        </p>
      </div>
    </footer>;
}